const csvExporter = (() => {
  const DEFAULT_MIME_TYPE = "text/csv;charset=utf-8";

  // Échappe une valeur pour l'insertion dans une cellule CSV
  const escapeValue = (value, separator) => {
    if (typeof value !== "string") return value;

    const needsEscaping = value.includes(separator) || value.includes('"') || value.includes("\n") || value.includes("\r");

    return needsEscaping ? `"${value.replace(/"/g, '""')}"` : value;
  };

  // Construit le contenu CSV complet (en-têtes + lignes) à partir de tableaux déjà formatés
  const buildCsvContent = (headers, rows, separator = ";") => {
    const csvLines = [headers.map(header => escapeValue(header, separator)).join(separator)];

    rows.forEach(row => {
      csvLines.push(row.map(cell => escapeValue(cell, separator)).join(separator));
    });

    return csvLines.join("\n");
  };

  // Génère un nom de fichier daté
  const generateFileName = (prefix, extension = "csv") => {
    const today = new Date().toISOString().slice(0, 10);
    return `${prefix}${today}.${extension}`;
  };

  // Crée et déclenche le téléchargement du fichier CSV
  const download = (csvContent, fileName, mimeType = DEFAULT_MIME_TYPE) => {
    try {
      // Ajouter le BOM UTF-8 pour la compatibilité Excel
      const bom = "\uFEFF";
      const blob = new Blob([bom + csvContent], { type: mimeType });

      const link = document.createElement("a");
      if (!("download" in link)) {
        console.warn("Téléchargement de fichier non supporté par ce navigateur");
        return false;
      }

      const url = URL.createObjectURL(blob);

      Object.assign(link, {
        href: url,
        download: fileName,
        style: { display: "none" }
      });

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Nettoyage différé pour éviter les problèmes de timing
      setTimeout(() => URL.revokeObjectURL(url), 100);

      return true;
    } catch (error) {
      console.error("Erreur lors du téléchargement:", error);
      return false;
    }
  };

  return {
    escapeValue,
    buildCsvContent,
    generateFileName,
    download
  };
})();

window.csvExporter = csvExporter;
export default csvExporter;
